<template>
<div class="chapter">
<div class="inner_page">
<h2 style="font-family: Calisto MT;">The Scars We Bear</h2>
<ul style="font-family: Calisto Mt; margin-left: -10px; margin-top: 20px; font-weight: normal !important;">
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Dedication</a></li>
<li><a href="#/index_split_002#toc_id_3">Copyright Information ©</a></li>
<li><a href="#/index_split_003#id_Toc146554277">Part One: Derek</a>
<ul>
<li><a href="#/index_split_004#id_Toc146554278">Prologue</a></li>
<li><a href="#/index_split_005#id_Toc146554279">Chapter 1</a></li>
<li><a href="#/index_split_006#id_Toc146554280">Chapter 2</a></li>
<li><a href="#/index_split_007#id_Toc146554281">Chapter 3</a></li>
<li><a href="#/index_split_008#id_Toc146554282">Chapter 4</a></li>
<li><a href="#/index_split_009#id_Toc146554283">Chapter 5</a></li>
<li><a href="#/index_split_010#id_Toc146554284">Chapter 6</a></li>
<li><a href="#/index_split_011#id_Toc146554285">Chapter 7</a></li>
<li><a href="#/index_split_012#id_Toc146554286">Chapter 8</a></li>
<li><a href="#/index_split_013#id_Toc146554287">Chapter 9</a></li>
<li><span href="#/index_split_014#id_Toc146554288" title="Link target outside of Sample">Chapter 10</span></li>
<li><span href="#/index_split_015#id_Toc146554289" title="Link target outside of Sample">Chapter 11</span></li>
<li><span href="#/index_split_016#id_Toc146554290" title="Link target outside of Sample">Chapter 12</span></li>
<li><span href="#/index_split_017#id_Toc146554291" title="Link target outside of Sample">Chapter 13</span></li>
<li><span href="#/index_split_018#id_Toc146554292" title="Link target outside of Sample">Chapter 14</span></li>
<li><span href="#/index_split_019#id_Toc146554293" title="Link target outside of Sample">Chapter 15</span></li>
<li><span href="#/index_split_020#id_Toc146554294" title="Link target outside of Sample">Chapter 16</span></li>
<li><span href="#/index_split_021#id_Toc146554295" title="Link target outside of Sample">Chapter 17</span></li>
<li><span href="#/index_split_022#id_Toc146554296" title="Link target outside of Sample">Chapter 18</span></li>
<li><span href="#/index_split_023#id_Toc146554297" title="Link target outside of Sample">Chapter 19</span></li>
<li><span href="#/index_split_024#id_Toc146554298" title="Link target outside of Sample">Chapter 20</span></li>
<li><span href="#/index_split_025#id_Toc146554299" title="Link target outside of Sample">Chapter 21</span></li>
<li><span href="#/index_split_026#id_Toc146554300" title="Link target outside of Sample">Chapter 22</span></li>
<li><span href="#/index_split_027#id_Toc146554301" title="Link target outside of Sample">Chapter 23</span></li>
<li><span href="#/index_split_028#id_Toc146554302" title="Link target outside of Sample">Chapter 24</span></li>
<li><span href="#/index_split_029#id_Toc146554303" title="Link target outside of Sample">Chapter 25</span></li>
<li><span href="#/index_split_030#id_Toc146554304" title="Link target outside of Sample">Chapter 26</span></li>
<li><span href="#/index_split_031#id_Toc146554305" title="Link target outside of Sample">Chapter 27</span></li>
<li><span href="#/index_split_032#id_Toc146554306" title="Link target outside of Sample">Chapter 28</span></li>
<li><span href="#/index_split_033#id_Toc146554307" title="Link target outside of Sample">Chapter 29</span></li>
<li><span href="#/index_split_034#id_Toc146554308" title="Link target outside of Sample">Chapter 30</span></li>
<li><span href="#/index_split_035#id_Toc146554309" title="Link target outside of Sample">Chapter 31</span></li>
<li><span href="#/index_split_036#id_Toc146554310" title="Link target outside of Sample">Chapter 32</span></li>
<li><span href="#/index_split_037#id_Toc146554311" title="Link target outside of Sample">Chapter 33</span></li>
<li><span href="#/index_split_038#id_Toc146554312" title="Link target outside of Sample">Chapter 34</span></li>
<li><span href="#/index_split_039#id_Toc146554313" title="Link target outside of Sample">Chapter 35</span></li>
</ul>
</li>
<li><span href="#/index_split_040#id_Toc146554314" title="Link target outside of Sample">Part Two: Ashley</span>
<ul>
<li><span href="#/index_split_041#id_Toc146554315" title="Link target outside of Sample">Prologue</span></li>
<li><span href="#/index_split_042#id_Toc146554316" title="Link target outside of Sample">Chapter One</span></li>
<li><span href="#/index_split_043#id_Toc146554317" title="Link target outside of Sample">Chapter Two</span></li>
<li><span href="#/index_split_044#id_Toc146554318" title="Link target outside of Sample">Chapter Three</span></li>
<li><span href="#/index_split_045#id_Toc146554319" title="Link target outside of Sample">Chapter Four</span></li>
<li><span href="#/index_split_046#id_Toc146554320" title="Link target outside of Sample">Chapter Five</span></li>
<li><span href="#/index_split_047#id_Toc146554321" title="Link target outside of Sample">Chapter Six</span></li>
<li><span href="#/index_split_048#id_Toc146554322" title="Link target outside of Sample">Chapter Seven</span></li>
<li><span href="#/index_split_049#id_Toc146554323" title="Link target outside of Sample">Chapter Eight</span></li>
<li><span href="#/index_split_050#id_Toc146554324" title="Link target outside of Sample">Chapter Nine</span></li>
<li><span href="#/index_split_051#id_Toc146554325" title="Link target outside of Sample">Chapter Ten</span></li>
<li><span href="#/index_split_052#id_Toc146554326" title="Link target outside of Sample">Chapter Eleven</span></li>
<li><span href="#/index_split_053#id_Toc146554327" title="Link target outside of Sample">Chapter Twelve</span></li>
<li><span href="#/index_split_054#id_Toc146554328" title="Link target outside of Sample">Chapter Thirteen</span></li>
<li><span href="#/index_split_055#toc_id_4" title="Link target outside of Sample">Chapter Fourteen</span></li>
<li><span href="#/index_split_056#id_Toc146554330" title="Link target outside of Sample">Chapter Fifteen</span></li>
<li><span href="#/index_split_057#id_Toc146554331" title="Link target outside of Sample">Chapter Sixteen</span></li>
<li><span href="#/index_split_058#id_Toc146554332" title="Link target outside of Sample">Chapter Seventeen</span></li>
<li><span href="#/index_split_059#toc_id_5" title="Link target outside of Sample">Chapter Eighteen</span></li>
<li><span href="#/index_split_060#id_Toc146554334" title="Link target outside of Sample">Chapter Nineteen</span></li>
<li><span href="#/index_split_061#id_Toc146554335" title="Link target outside of Sample">Chapter Twenty</span></li>
<li><span href="#/index_split_062#id_Toc146554336" title="Link target outside of Sample">Chapter Twenty-One</span></li>
<li><span href="#/index_split_063#id_Toc146554337" title="Link target outside of Sample">Chapter Twenty-Two</span></li>
<li><span href="#/index_split_064#id_Toc146554338" title="Link target outside of Sample">Chapter Twenty-Three</span></li>
<li><span href="#/index_split_065#id_Toc146554339" title="Link target outside of Sample">Chapter Twenty-Four</span></li>
<li><span href="#/index_split_066#id_Toc146554340" title="Link target outside of Sample">Chapter Twenty-Five</span></li>
<li><span href="#/index_split_067#id_Toc146554341" title="Link target outside of Sample">Chapter Twenty-Six</span></li>
<li><span href="#/index_split_068#id_Toc146554342" title="Link target outside of Sample">Chapter Twenty-Seven</span></li>
<li><span href="#/index_split_069#id_Toc146554343" title="Link target outside of Sample">Chapter Twenty-Eight</span></li>
<li><span href="#/index_split_070#id_Toc146554344" title="Link target outside of Sample">Chapter Twenty-Nine</span></li>
<li><span href="#/index_split_071#id_Toc146554345" title="Link target outside of Sample">Chapter Thirty</span></li>
<li><span href="#/index_split_072#id_Toc146554346" title="Link target outside of Sample">Chapter Thirty-One</span></li>
</ul>
</li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6b03d922